export default "__VITE_ASSET__VN0dXvN9__"